import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { PRIORITY_META, type LeadPriority } from '../lib/leadMeta';
import { BADGE_POP } from '../lib/motion';

interface PriorityBadgeProps {
  priority: string;
  className?: string;
}

/** Priority badge that pops when its value changes (e.g. after "Set high priority"). */
export function PriorityBadge({ priority, className }: PriorityBadgeProps) {
  const meta = PRIORITY_META[priority as LeadPriority] ?? PRIORITY_META.low;
  const Icon = meta.icon;

  return (
    <Badge variant="outline" className={cn('gap-1 whitespace-nowrap font-medium', meta.className, className)}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={priority}
          className="inline-flex items-center gap-1"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.85 }}
          transition={BADGE_POP}
        >
          <Icon className="h-3 w-3" aria-hidden="true" />
          {meta.label}
        </motion.span>
      </AnimatePresence>
    </Badge>
  );
}
